// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__18y2U","navbarHidden":"Menu_navbarHidden__1dzgp"};